// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"561":"a2e4155810ef0647","884":"1ff5976617d026d3","923":"2f94cbd1467eb363"}[chunkId] + ".js";
};